<rds-form-field labelPosition="top">
  <rds-control-label>{{ config.label }}</rds-control-label>
  <rds-autocomplete
    [ngModel]="user"
    [options]="data"
    [optionsContainerClass]="optionsContainerClass"
    [disabled]="disabled"
    [placeholder]="config.placeholder"
    [minSearchChars]="minSearchChars"
    [displayProperty]="displayProperty"
    [uniqProperty]="uniqProperty"
    (shown)="onDropdownShown()"
    (hidden)="onDropdownHidden()"
    (ngModelChange)="onInputChange($event)"
    (blur)="propagateTouched()"></rds-autocomplete>
</rds-form-field>
